/**
 * Typed ops guard dashboard API facade over the generated contract client.
 */

import { opsGuardDashboardApi } from '../api/generated/opsGuardDashboard.api.js';
import {
  type GuardDashboardListQuery,
  type GuardDashboardListResponse,
} from '@cnapse/shared/schemas.js';

class OpsGuardDashboardService {
  async getGuardDashboardList(query: GuardDashboardListQuery): Promise<GuardDashboardListResponse> {
    return opsGuardDashboardApi.list(query) as Promise<GuardDashboardListResponse>;
  }
}

export const opsGuardDashboardService = new OpsGuardDashboardService();
